import type { UtmParameters } from './utm-parameters';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

/**
 * `url` with the given tags, replacing any it already had.
 *
 * Replacing rather than appending, because a visitor who arrived from WhatsApp and shares onwards to
 * Telegram would otherwise pass on two `utm_source`s, and GA reads the first — crediting WhatsApp for
 * a visit Telegram brought. Every `utm_*` is dropped first, so a stale `utm_term` does not survive
 * either. The rest of the query and the fragment are kept.
 */
export function withUtm(url: string, utm: UtmParameters): string {
    const tagged = new URL(url);

    for (const key of UTM_KEYS) {
        tagged.searchParams.delete(key);
    }

    tagged.searchParams.set('utm_source', utm.source);
    tagged.searchParams.set('utm_medium', utm.medium);
    tagged.searchParams.set('utm_campaign', utm.campaign);

    if (utm.content !== undefined && utm.content !== '') {
        tagged.searchParams.set('utm_content', utm.content);
    }

    return tagged.toString();
}
